import React from 'react';
import Error from './error_message';
import Input from './input';
import Button from './button';
import setValue from 'helpers/set_value';

interface AutopaymentsBluefinFormProps {
  errors: any;
  paymentSystemAccount: any;
  save: () => void;
  setForm: (form: any) => void;
}

const AutopaymentsBluefinForm = ({
  errors,
  paymentSystemAccount,
  save,
  setForm,
}: AutopaymentsBluefinFormProps) => {
  return (
    <div>
      <div className="clearfix payment-provider">
        <div className="payment-provider-logo">
          <img alt="Bluefin" src="/bluefin.png" />
        </div>
        <p>
          <strong>Bluefin credentials</strong>
        </p>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">Bluefin Account ID</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.account_id}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'account_id', value));
            }}
          />
          <Error error={errors['payment_system_account.response']} />
          <Error error={errors['payment_system_account.account_id']} />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">API Access Key</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.secret_key}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'secret_key', value));
            }}
          />
          <Error error={errors['payment_system_account.secret_key']} />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3"></div>
        <div className="col-sm-6 ">
          <Button
            variant="success"
            onClick={save}
            disabled={!paymentSystemAccount.account_id || !paymentSystemAccount.secret_key}
          >
            Connect
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutopaymentsBluefinForm;
